module.exports = __webpack_public_path__ + "static/media/Circle.2b28a577.png";